/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/authService/auth.service';
import { AppInitializerService } from '../services/app-initializer.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private appInitializer: AppInitializerService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.fetchValidToken().then(async (TokenValid) => {
      if (!TokenValid) {
        this.appInitializer.resetInitialization();
        this.router.navigate(['/login']);
        return false;
      }

      // If user is authenticated, ensure app is initialized before allowing navigation
      try {
        console.log('Initializing app in auth guard');
        await this.appInitializer.initializeApp();
        return true;
      } catch (error) {
        console.error('App initialization failed in auth guard:', error);
        // Even if initialization fails, allow navigation but user will see error state
        this.appInitializer.resetInitialization();
        this.router.navigate(['/login']);
        return false;
      }
    });
  }
}
